export enum MessageHandlerKind {
    Default = 'default',
    MeetingRoom = 'meeting-room',
    TeleMessenger = 'telemessenger',
}

interface GetMessageHandlerKindParams {
    isMeetingRoomIntegration: boolean;
    isTeleMessenger: boolean;
}

export const getMessageHandlerKind = ({
    isMeetingRoomIntegration,
    isTeleMessenger,
}: GetMessageHandlerKindParams): MessageHandlerKind => {
    if (isMeetingRoomIntegration) {
        return MessageHandlerKind.MeetingRoom;
    }

    if (isTeleMessenger) {
        return MessageHandlerKind.TeleMessenger;
    }

    return MessageHandlerKind.Default;
};
